<template>
<div>
  <Header :Act="2"></Header>
  <div class="research-list-container">
    <div class="research-content">
      <div class="research-header">
        <h1>科普调研</h1>
        <div class="research-description">
          <p>百姓巡常行项目科普调研活动，聚焦百姓健康需求，收集健康科普素材</p>
        </div>
      </div>
      
      <div class="research-items">
        <!-- 文章列表 -->
        <div class="research-item" v-for="item in researchItems" :key="item.id" @click="navigateToArticle(item.id)">
          <div class="research-item-content">
            <h3>{{ item.title }}</h3>
            <p class="research-excerpt">{{ item.content }}</p>
            <div class="research-info">
              <span>百姓巡常行</span>
              <span>{{ item.date }}</span>
              <span>{{ item.views }}次浏览</span>
            </div>
          </div>
          <div class="research-img">
            <img :src="item.imageUrl" :alt="item.title">
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</div>
</template>

<script>
import Header from '@/components/header/head'
import Footer from '@/components/header/footer'

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      researchItems: [
        {
          id: 3,
          title: '您点题，我出书——"百姓巡常行"项目健康科普系列图书选题调研全面开启',
          imageUrl: require("@/assets/小资讯1.png"),
          content: "健康中国行动在祖国大地上如火如荼地开展着，各类机构和社会组织也用实际行动纷纷持续助力。由中国健康教育中心指导，北京整合医学学会主办的\"健康中国行动——百姓健康卫士公益科普'百姓巡常行'项目\"正是这样的一个实践项目。该项目将通过促进健康科普作品创作和传播、出版百姓期待的健康科普系列图书等形式，形成健康科普和健康促进合力，持续、稳定地开展健康科普活动。",
          date: "2025-03-14",
          views: "1524"
        },
        {
          id: 4,
          title: '您点题 我出书｜百姓健康卫士公益科普"百姓巡常行"项目继续征集选题',
          imageUrl: require("@/assets/小资讯2.png"),
          content: "健康中国行动的推进过程中，健康科普工作发挥着至关重要的作用。由中国健康教育中心指导，北京整合医学学会主办的\"健康中国行动——百姓健康卫士公益科普'百姓巡常行'项目\"积极响应号召，致力于出版贴合百姓需求的健康科普系列作品。继河南新乡调研科普图书主题取得丰硕成果后，项目调研组于3月12-14日赶赴山东菏泽，深入开展线下调研访谈活动，聚焦不同群体的健康需求，为健康科普图书的创作与出版收集第一手资料。",
          date: "2025-03-24",
          views: "1376"
        },
        {
          id: 1,
          title: '百姓巡常行项目健康科普作品征集活动正式启动',
          imageUrl: require("@/assets/最新资讯.png"),
          // imageUrl: require("@/assets/jilin.png"),
          content: '百姓巡常行项目健康科普作品征集活动现已正式启动，面向全国医疗卫生机构的专业医务人员征集健康科普作品。征集内容包括科普文章、科普图画、科普视频和科普讲座等多种形式。欢迎各位医务工作者积极参与，共同为提升全民健康素养贡献力量。',
          date: "2025-03-31",
          views: "1285"
        }
      ]
    };
  },
  created() {
    // 不再需要获取浏览量数据
  },
  methods: {
    navigateToArticle(id) {
      // 找到对应的文章
      const article = this.researchItems.find(item => item.id === id);
      if (article) {
        // 将文章信息存储到localStorage，以便在文章页面获取
        localStorage.setItem('currentArticle', JSON.stringify(article));
        // 跳转到文章页面
        this.$router.push('/article/' + id);
      }
    }
  }
}
</script>

<style scoped>
.research-list-container {
  padding-top: 50px;
}

.research-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 30px;
}

.research-header {
  text-align: center;
  margin-bottom: 30px; /* 减少底部间距 */
}

.research-header h1 {
  font-size: 32px; /* 略微减小标题 */
  color: #333;
  margin-bottom: 15px; /* 减少底部间距 */
}

.research-description {
  font-size: 16px; /* 减小说明文字 */
  color: #666;
  max-width: 800px;
  margin: 0 auto;
  margin-bottom: 10px; /* 增加底部间距 */
}

.research-items {
  display: flex;
  flex-direction: column;
  gap: 20px; /* 减少条目间距 */
  margin-bottom: 50px;
}

.research-item {
  display: flex;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
}

.research-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.research-item-content {
  flex: 2;
  padding: 25px;
}

.research-item-content h3 {
  font-size: 22px;
  color: #333;
  margin-bottom: 15px;
}

.research-excerpt {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.research-info {
  display: flex;
  gap: 15px;
  color: #999;
  font-size: 14px;
}

.research-img {
  flex: 1;
  max-width: 300px;
}

.research-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .research-list-container {
    padding-top: 50px; /* 移动端减少顶部内边距 */
  }
  
  .research-content {
    padding: 15px;
  }
  
  .research-header {
    margin-bottom: 20px; /* 移动端进一步减少标题底部间距 */
  }
  
  .research-header h1 {
    font-size: 24px; /* 移动端进一步减小标题 */
    margin-bottom: 10px;
  }

  .research-items {
    gap: 15px; /* 移动端进一步减少条目间距 */
  }

  .research-item {
    flex-direction: column;
  }

  .research-item-content {
    order: 2;
    padding: 20px;
  }

  .research-item-content h3 {
    font-size: 18px;
  }

  .research-excerpt {
    font-size: 14px;
    -webkit-line-clamp: 2;
  }

  .research-img {
    order: 1;
    max-width: 100%;
    height: 200px;
  }
}
</style> 